import { render, staticRenderFns } from "./HistoryInfoLayer.vue?vue&type=template&id=144a5549&"
import script from "./HistoryInfoLayer.vue?vue&type=script&lang=ts&"
export * from "./HistoryInfoLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports